import { Injectable } from '@angular/core';
import { IPaymentErrorResult, IPaymentStatus } from 'libs/shared/src/models';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export abstract class BasicPaymentProvider {
  // Properties & Signals
  /** Emits the result received from the payment provider */
  abstract resultReceived: Observable<IPaymentStatus | undefined>;

  // Methods
  /**
   * Initializes the payment provider / gets called on the first usage on a page
   * @example load the script of the payment provider // get url params after a redirect
   */
  abstract initializeProvider(): void;

  /**
   * Initializes a Payment with the given transactionToken
   * @param transactionToken to use for identification at the payment provider
   * @param redirectUrl optional redirect url to use after payment
   * @example open payment window in a new tab
   */
  abstract initializePayment(transactionToken: string, redirectUrl?: string): void;

  /**
   * Generates a user-friendly message based on the payment status and optional error result
   * @param status of the payment
   * @param result optional error result from the payment provider
   */
  abstract generateStatusMessage(status: IPaymentStatus, result?: IPaymentErrorResult<unknown>): string | undefined;
}
